export const GetApplicationUserSecurity =
  "/ApplicationUser/GetApplicationUserSecurity";

export const GetTwoFactorAppEnable = "/ApplicationUser/GetTwoFactorAppEnable";
export const GetTwoFactorAppDisable = "/ApplicationUser/GetTwoFactorAppDisable";
export const GetTwoFactorSMSEnable = "/ApplicationUser/GetTwoFactorSMSEnable";
export const GetTwoFactorSMSDisable = "/ApplicationUser/GetTwoFactorSMSDisable";

export const SendEmailTwoFA = "/ApplicationUser/SendEmailTwoFA";
export const SendSMSTwoFA = "/ApplicationUser/SendSMSTwoFA";

export const TwoFactorAppEnable = "/ApplicationUser/TwoFactorAppEnable";
export const TwoFactorAppDisable = "/ApplicationUser/TwoFactorAppDisable";
export const TwoFactorSMSEnable = "/ApplicationUser/TwoFactorSMSEnable";
export const TwoFactorSMSDisable = "/ApplicationUser/TwoFactorSMSDisable";
